import React, { Component } from "react";

export default class StepperTemplate4 extends Component {
  constructor(props) {
    super(props);
    this.scrollRef = React.createRef();
    this.isLast = this.isLast.bind(this);
    this.activeFunc = this.activeFunc.bind(this);
    this.completedFunc = this.completedFunc.bind(this);
    this.stepperFunc = this.stepperFunc.bind(this);
    this.titleColor = this.titleColor.bind(this);
    this.backgroundColor = this.backgroundColor.bind(this);
  }

  isLast(index) {
    return index === this.props.steps.length - 1;
  }

  stepperFunc(index, ele) {
    if (!this.isLast(index) && !this.props.backNotAllowed) {
      ele && ele.onClick();
    }
  }

  activeFunc(index) {
    return (
      !(this.props.disabledSteps || []).includes(index) &&
      index === this.props.activeStep
    );
  }

  completedFunc(index) {
    return (
      !(this.props.disabledSteps || []).includes(index) &&
      index < this.props.activeStep
    );
  }

  titleColor(i) {
    return this.activeFunc(i)
      ? this.props.activeTitleColor
      : this.completedFunc(i)
      ? this.props.completeTitleColor
      : this.props.defaultTitleColor;
  }

  backgroundColor(i) {
    return this.completedFunc(i)
      ? this.props.completeColor
      : this.props.defaultColor;
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.activeStep !== this.props.activeStep) {
      if (this.scrollRef.current) {
        if (this.props.activeStep == 4 && this.props.steps.length > 5) {
          this.scrollRef.current.scrollTo({
            left: this.scrollRef.current.scrollWidth,
            behavior: "smooth",
          });
        }
      }
    }
  }
  

  render() {
    return (
      <div className="stepper-template3" ref={this.scrollRef}>
        <div
          className={`inner-template ${
            this.props.steps.length > 5 ? "scroll-stepper-width" : ""
          } ${
            this.props.steps.length == 4
              ? "three"
              : this.props.steps.length == 3
              ? "two"
              : ""
          }`}
        >
          {this.props.steps.map((ele, i) => {
            return (
              <div
                key={i}
                title={ele && ele.title}
                className={`stepper-indicator-sec 
                ${this.completedFunc(i) ? "completed" : ""} 
                ${this.activeFunc(i) ? "active" : ""} 
                ${this.activeFunc(i + 1) ? "prev" : ""}`}
                onClick={() => this.stepperFunc(i, ele)}
                style={{
                  backgroundColor: this.backgroundColor(i),
                }}
              >
                <div
                  className="active-arrow"
                  style={{ backgroundColor: this.props.activeColor }}
                ></div>
                <span className="stepper-title">
                  <div
                    className="tick-icon-sec"
                    style={{
                      color: this.titleColor(i),
                    }}
                  >
                    {this.completedFunc(i) && ele.icon ? ele.icon : `${i + 1}`}{" "}
                  </div>
                  <div
                    className="txt-sec"
                    style={{
                      color: this.titleColor(i),
                    }}
                  >
                    {ele && ele.title}
                  </div>
                </span>
              </div>
            );
          })}
        </div>
      </div>
    );
  }
}
